import React from 'react'

import { ReactComponent as PlusIcon } from '@app/assets/Small/Outline/Plus.svg'
import { useIntl } from '@app/intl/Intl'
import { bemJoin } from '@app/lib/bem'
import { IconBadge } from '@app/lib/display/IconBadge/IconBadge'

import './UploadDocumentButton.scss'

type UploadDocumentButtonProps = {
  onClick: () => void
  disabled?: boolean
}

export const UploadDocumentButton = ({ onClick, disabled }: UploadDocumentButtonProps) => {
  const b = bemJoin('upload-document-button')
  const { formatMessage } = useIntl()

  return (
    <button aria-label='Upload Button' className={b()} onClick={onClick} disabled={disabled}>
      <IconBadge className={b('icon')} color={disabled ? 'neutral' : 'secondary'} size='smd'>
        <PlusIcon />
      </IconBadge>
      <span className={b('text')}>{formatMessage({ id: 'UploadDocumentButton.Text' })}</span>
    </button>
  )
}
